<template>
  <div>
    <Modal v-model="isShow" @on-ok="ok" :loading="loading" :mask-closable="false">
      <h3 slot="header" class="modal-header">房型轮播图</h3>
      <Row class="row" >
        <Col span="2">排序</Col>
        <Col span="4">分类</Col>
        <Col span="10">描述</Col>
        <Col span="2">图片</Col>
        <Col span="4">配置物品</Col>
        <Col span="2">操作</Col>
      </Row>
      <Row class="row" v-for="(item,index) in data " :key="item.fid">
        <Col span="2">
          <Input class="width30" v-model="item.labelOrder" />
        </Col>
        <Col span="4">
          <Input class="width80" v-model="item.labelName"/>
        </Col>
        <Col span="10">
          <Input class="width150" v-model="item.remark"/>
        </Col>
        <Col span="2">
          <a @click.stop="uploadImg(item)">配置</a>
        </Col>
        <Col span="4">
          <span v-if="!item.fid">-</span>
          <a v-else @click.stop="houseTypeConfig(item)">配置</a>
        </Col>
        <Col span="2">
          <a @click.stop="deleteItem(item,index)">删除</a>
        </Col>
      </Row>
      <div class="mt20">
        <a @click.stop="addItem">+ 添加</a>
      </div>
      <img-upload :n="uploadN" :fid="configFid" :houseTypeFid="houseTypeFid" :orderId="orderId" @pic="pic" :pics="pics" :num="1"></img-upload>
      <house-type-cofig :houseTypeFid="houseTypeFid" :n="houseTypeConfigKey" :labelFid="labelFid"></house-type-cofig>
      <!--<div slot="footer"></div>-->
    </Modal>
  </div>

</template>

<script>
  // import {labelgetConfigImg} from "../../../../api/projectConfig";
  import ImgUpload from './ImgUpload'
  import {labellist,labeledit,labelremove} from "api/projectConfig";
  import {isType} from "../../../../utils/public";
  import HouseTypeCofig from './HouseTypeCofig'
  export default {
    name: "ImgConfig",
    components:{
      ImgUpload,
      HouseTypeCofig
    },
    props:{
      n: {
        type: Number,
        default: 0
      },
      fid:{
        type:String,
        default:''
      },
      houseTypeFid:{
        type:String,
        default:''
      }
    },
    watch:{
      n(){
        this.labellist()
        this.isShow=true
      },
      // fid(){
      //   this.labellist()
      // }
    },
    data(){
      return {
        uploadN:0,
        isShow:false,
        data:[],
        orderId:0,
        loading:true,
        configFid:'',
        pics:[],
        houseTypeConfigKey:0,
        labelFid:"",
      }
    },
    methods:{
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      houseTypeConfig(item){
        this.labelFid=item.fid
        this.houseTypeFid=this.houseTypeFid
        this.houseTypeConfigKey++
      },
      addItem(){
        let order=1
        if(this.data.length > 0){
          order = this.data[this.data.length-1].labelOrder;
          if((+order).toString()==='NaN' || !isType('Number',+order)){
            order = this.data.length+1;
          }else{
            order = parseInt(order)+1;
          }
        }
        this.data.push({
          "fid": "",
          "labelName": "",
          "labelOrder": order,
          "picUrl":[],
          "labelType": 0,
          "moduleId": ""
        })
      },
      labellist(){
        if(!this.fid){
          return
        }
        var params={
          moduleFid:this.fid,
          type:0
        }
        labellist(params).then(res=>{
          this.data=res.data
        })

      },
      uploadImg(item){
        this.pics = []
        let order = item.labelOrder
        if(!order){
          this.$Message.info('请先添加排序')
          return
        }
        if((+order).toString()==='NaN' || !isType('Number',+order)){
          this.$Message.info('排序字段为数字')
          return
        }
        let labelOrder = this.data.filter(item => item.labelOrder==order)
        if(labelOrder && labelOrder.length > 1 ){
          this.$Message.info('排序字段不能重复')
          return
        }
        if(!item.picUrl){

        }else{
          this.pics = item.picUrl
        }

        this.configFid=item.fid
        this.orderId=order
        this.uploadN++
      },

      deleteItem(item,index){

        this.$Modal.confirm({
          content: '<p>确认删除？</p>',
          onOk: () => {
            if(item.fid){
              let params={
                fid:item.fid
              }
              labelremove(params).then(res=>{
                this.$Message.success('删除成功')
                this.labellist()
              })
            }
            else {
              this.data.splice(index,1)
            }
          }
        })
      },
      ok(){
        let a1=[]
        let isNull=false
        let isnotNumber=false
        let isOverLength=false
        let isPicNull=false

        if(this.data.length < 1){
          this.changeLoading()
          this.$emit('refresh')
          this.isShow = false
          return
        }

        this.data.forEach(ele=>{
          if(!ele.labelName || !ele.labelOrder){
            isNull=true
            return
          }

          if((+ele.labelOrder).toString()==='NaN' || !isType('Number',+ele.labelOrder)){
            isnotNumber=true
            return
          }else{
            if(ele.labelOrder <= 0){
              isnotNumber=true
              return
            }
          }
          a1.push(ele.labelOrder+'')
          if(ele.labelName.length > 10 || (ele.remark && ele.remark.length > 200)){
            isOverLength = true
            return
          }
          if(!ele.fid && ele.picUrl.length < 1){
            isPicNull = true
            return
          }
        })

        if(isPicNull){
          this.$Message.info('图片必传')
          this.changeLoading()
          return
        }
        if(isNull){
          this.$Message.info('排序或标签名不能为空')
          this.changeLoading()
          return
        }

        if(isnotNumber){
          this.$Message.info('排序必须为数字,且不能小于等于0')
          this.changeLoading()
          return
        }

        let a2=new Set(a1)
        if(a1.length!== a2.size){
          this.$Message.info('排序不能重复')
          this.changeLoading()
          return
        }
        if(isOverLength){
          this.$Message.info('分类字数不能超过10个，描述字数不能超过200')
          this.changeLoading()
          return
        }

        var params={
          moduleFid:this.fid,
          labelEntities:this.data,
          proHouseTypeFid:this.houseTypeFid,
          type:2
        }
        labeledit(params).then(res=>{
          this.$Message.success('标签保存成功')
          this.changeLoading()
          this.$emit('refresh')
          this.isShow = false
        })
      },
      pic(data){
        if(data.length < 1){
          return
        }
        this.pics = []
        var order = data[0].order
        let labelOrder = this.data.filter(item => {return item.labelOrder==order})
        labelOrder[0].picUrl = []
        data.forEach(item => {
          labelOrder[0].picUrl.push(item)
        })
      }

    },
    created(){
      // this.labellist()
    }

  }
</script>

<style scoped>
  .width150{
    width: 100px;
  }
  .width30{
    width: 30px;
  }
  .width80{
    width: 80px;
  }
  .row {
    text-align: center;
    /*margin-bottom: 10px;*/
    line-height: 32px;

    border-left: 1px solid rgb(222, 222, 222);
    border-right: 1px solid rgb(222, 222, 222);
    border-bottom: 1px solid rgb(222, 222, 222);
    padding: 7px;
  }

  .row:first-child {
    border-top: 1px solid rgb(222, 222, 222);
    background-color: rgb(248, 248, 248);
    padding: 5px;
  }

</style>
